import React, { useState } from 'react'

import {
  EventCancelledCardEdit,
  EventResultData,
} from './EventCancelledCardEdit'
import { EventCancelledCardView } from './EventCancelledCardView'

import { ScriptStep } from '@/constants'
import { Event } from '@/types'

type EventCancelledCardProps = {
  title?: string
  event: Event
  value: EventResultData
  canceledFromStep: ScriptStep | string | null
  onSubmitClick: (data: EventResultData) => void
}

export const EventCancelledCard: React.FC<EventCancelledCardProps> = ({
  title,
  event,
  value,
  canceledFromStep,
  onSubmitClick,
}) => {
  const [isEdit, setIsEdit] = useState(false)

  return isEdit ? (
    <EventCancelledCardEdit
      title={title}
      event={event}
      value={value}
      onSubmitClick={data => {
        onSubmitClick(data)
        setIsEdit(false)
      }}
      canceledFromStep={canceledFromStep}
    />
  ) : (
    <EventCancelledCardView
      title={title}
      event={event}
      onEditClick={() => setIsEdit(true)}
      value={value}
    />
  )
}
